export const betflag = [
    '6C9D1588-A442-4CB5-99A7-CE542CB578CF', // staging
    '2F1ABD87-5863-4BCA-BEA8-155E4CA42741',
    '459918A2-A1CB-4211-8DB3-A8D43688C279', // produzione
];
export const sisal = [
    '72272D57-7598-4C4E-BC76-F1BF142C8E74', // staging
    '6C0EA555-2DA3-44B4-BC97-3A32368E2853', // produzione
];
export const sks = [
    'C112A683-C568-4A8B-8BF9-8F64DEF62ED1', // staging
    '689BD399-2F04-4669-AA93-55DBFE6A9685', // Produzione
];
export const parimatch = [
    '10802F1D-3F51-4B96-A115-9CA509189918', // staging PARIMATCH RUB
    '98F0D64C-D8C1-4CC3-AF52-4226D36C5523', // staging PARIMATCH UAH
    'C0DEB55D-76CD-4FDE-9C08-DE18CDEB89DE', // staging PARIMATCH USD
    'D37557F1-E450-41B8-8CD2-ED83F94D98CE', // staging PARIMATCH EUR
    'E10B8B46-DC28-404B-8BC9-16C205AAF1FD',	// staging PARIMATCH CAD
    '72089B4F-F5B4-4A82-869C-D229B3A6B1FB',	// staging PARIMATCH INR
    '8833198D-058C-40D4-90B1-FE50AA1068A8',	// staging PARIMATCH MYR
    'AED570D8-A01F-4A30-9F57-FD5FDF0EBFBA',	// staging PARIMATCH BTD
     // Produzione
    '2AD49F3B-25C9-4FFE-8D95-10B057D66761',	// PARIMATCH CAD
    'B1D05546-8F9C-42F5-8B12-2DBF29E4DF37',	// PARIMATCH UAH
    'A716301C-B5C3-4F3F-A98D-62BE5065CF88',	// PARIMATCH RUB
    '2F3D4E60-2F83-469E-ABFD-6F5C71599877',	// PARIMATCH EUR
    '509E85BF-2F85-4FB6-8B13-87DD97BA2874',	// PARIMATCH USD
    'F8DCF500-547F-41C4-9848-48D7F004AC1F',	// PARIMATCH INR
    'CED28079-E892-4FAC-AC07-2A1C0F956881',	// PARIMATCH MYR
    '89A86031-3652-4DBF-AC91-BADC7CD7BD98',	// PARIMATCH BTD

    // CID di test
    'A2ACD5E8-FAF5-4F67-9B98-EC21F79C2450'
];
export const ngenge = [
    '5041E7DD-5924-4F7F-8405-43C5FE8BD621', // staging NGENGE EUR
    'BF82CF2C-CCB7-4826-AF61-27F825BFEB7F', // Staging NGENGE USD
    '3C2AF2FD-08EE-4DE1-A4EC-0A19132D6B48', // Staging NGENGE
    // Produzione
    '079BE601-2704-4F83-8B77-32B29C19F2A0', // Produzione NGENGE
    '3ECDAD4B-5130-4339-9049-658AAC92821C', // Produzione NGENGE
    'F59A7B8E-2A61-469E-AD98-DF91BC1DC7AC', // Produzione NGENGE
];
export const quigioco = [
    '0D9E3A88-9EC5-434C-9C78-E940B375ABFD', // staging
    '28A5C359-8A64-46F1-A68B-ADE361BAC534' // produzione
];
export const youbet = [
    '7AF997B2-643C-4638-8B46-C93B11B45A61', // staging
    '7A21E8E4-9F3C-48A0-A5DC-503030C013A1' // produzione
];
export const trebet = [
    'EC458504-9D92-4E6A-BBCE-3C4C28060A41', // staging
    'CB414B68-699A-4030-8B7B-AB5FA9428AB1' // produzione
];
export const bet2020 = [
    '150393B2-B74C-48ED-83E5-2F3ACC1FC4A2', // staging
    '6A860A7C-2A1F-48EF-86F8-9777D0B62B6B' // produzione
];
export const betplus = [
    'DC5840B5-85B5-41EA-969F-BF0C41BFDE59', // staging
    'C6E9A04F-3902-4A55-B1DD-01D5AD754D6B', // produzione
];
export const gsbet = [
    '20D16F6F-7F49-4530-9D12-25C3C61DE85A', // produzione
];
export const millionairebet = [
    '8335158B-1B2F-4348-957B-51553F4FD268', // staging
    'D6EF672E-4446-47DF-82AD-AB85F430DADA', // produzione
];
export const mst = [
    'AB396718-9768-406F-8320-BEA0E940CB75', // Produzione MST
    '2F1ABD87-5863-4BCA-BEA8-155E4CA42741', // staging MST
];
export const eurobet = [
    '6770EB7C-32F4-42C2-9E29-9DAE9FFB3898', // staging
    'AC3FA1BC-BAF6-4CA1-9D03-2C6FA7FE73F1' // produzione
];

export const betland = [
    '634FED17-7514-48A5-8B17-468B6C0C4E33', // Staging Test Betaland OIA
    '8A7D12AC-2656-4FEB-9C4A-19FF42BA83F5' // produzione
];
export const enjoybet = [
    '8275C9EB-F76D-4C49-8FB9-35A1536799C6', // Staging Test Enjoybet OIA
    '703ACB4B-B6EE-457B-9D91-63DC625473EC' // produzione
];
export const riogames = [
    '90A0DCA8-C841-433A-A9BE-DC8B11119073', // Staging Test Riogames OIA
    '323C1983-D471-4AE4-A14F-CF35F0EC85FF' // produzione
];
export const betup = [
    'BB4A84C3-B8E8-4A7E-BE6E-0B6285A35132', // Staging Betup
    'B4DA04CD-5B34-4928-A7CE-944AB7AE3673' // produzione
];
export const italianbet24 = [
   '3478090C-8C35-48FF-AC74-1CFEDE1CD433', // Staging Italianbet24
    '5EAE9E67-DD6D-40A9-8E89-DAFB92805127' // produzione
];
export const sbancami = [
    'F14C3ADB-1FE6-4FD0-ACDA-807094551BD2',    // Staging Sbancami
    'AF8ADA4B-C089-4D16-869E-F38F7EB61511'  // produzione
];
export const pokerblu =  [
    '0377EF16-494D-42F9-98EB-ED7373AF4D52',    // Staging pokerblu
    '47521806-4949-4437-AAAA-35F0C989999C'  // produzione
];
export const scommesseitalia = [
    'FE1F6A27-B7D6-4525-80C2-00F7A7EA4239', // Staging Scommesseitalia
    '01CC9950-73E3-4D16-9831-348406625A40', // scommesseitalia
    ]
    .concat(italianbet24)
    .concat(sbancami)
    .concat(pokerblu);

export const betpoint = [
    '17C728ED-82D3-4C49-8B32-0DC86E0F38C2', // Staging BETPOINT
    '31EFD458-DAAD-453D-A1FF-1E52CDD2F809', // Staging JOYGAMES
    '76A629F4-CAC5-4542-9B90-8429D01E2C30', // Staging WINTIMECASINO
    '17F33881-FF7F-4C2A-B312-CF26188B6BDB', // Staging EDICOLAGAMES

    '522328EA-C271-4CBA-8A36-12D1735BEBE1', // BETPOINT
    '26A6041F-4F19-46FE-B4EA-4D3A40569076', // JOYGAMES
    '551D35CC-1D4F-42C0-AAE5-A281AE180F58', // EDICOLAGAMES
    'C1A68D08-199D-4B63-B706-C2B2DC919A80', // WINTIMECASINO
];

export const microgameDark = [
    // TEST
    '64C08DAC-6E4C-40EB-870C-58D5ED32D768', // Staging Test Microgame

    'E8CD9BBD-BF67-4156-0002-8F79C7950207',	// 15073	MG REPLATZ (15073) Betman DARK
    '6CBB64AF-3BFA-43F0-0002-9031DA2403C8',	// 15073	MG REPLATZ (15073) Replatz DARK
    'E62C3DEA-20FD-4F13-0002-0EE8487DB021',	// 15074	MG GI.LU.PI. (15074) Giocasempre DARK
    '06EEBAC3-7100-45EA-0002-EE42F1327911',	// 15074	MG GI.LU.PI. (15074) Betscore DARK
    '08E2817C-6E8D-4BAE-0002-F7C7882BD063',	// 15074	MG GI.LU.PI. (15074) Betitaly DARK
    'F8864412-00EE-47D3-0002-9DA5F7108F89',	// 15092	MG PLIVIO (15092) Eventogioco DARK
    '9439F5C1-0697-435E-0002-BA008138741D',	// 15092	MG PLIVIO (15092) Eventogiocobet DARK
    '9236D5AA-AB59-473B-0002-276FB0429BD1',	// 15188	MG VITTORIA BET 2009 (15188) Deabet DARK
    'BA2F4385-A537-46B2-0002-86EDB3F42262',	// 15188	MG VITTORIA BET 2009 (15188) Chancebet DARK
    'F9251ED8-B9CF-401C-0002-8A64E8B50E93',	// 15188	MG VITTORIA BET 2009 (15188) Andromedabet DARK
    '9E997CDF-F7F8-49A7-0002-92C7D18C28F5',	// 15188	MG VITTORIA BET 2009 (15188) Lafenicebet DARK
    '7BB8BF4C-8B31-4AF0-0002-A90F9F051683',	// 15188	MG VITTORIA BET 2009 (15188) Bettime DARK
    'EE17B44E-77E9-482B-0002-D0AB2E1E17B2',	// 15188	MG VITTORIA BET 2009 (15188) Wintoto DARK
    '04E8007B-5737-40CC-0002-5B0F64169708',	// 15405	MG TOTOSI (15405) Totosi DARK
    '1DC89CFB-1763-40F7-0002-1C11644DCD62',	// 15411	MG PLAYMATIKA (15411) Betnow DARK
    '03FCFEA9-C818-4C24-0002-A416DCEBB975',	// 15411	MG PLAYMATIKA (15411) Playmatika DARK
    '65E26070-E679-4544-0002-FB45A4E0964D',	// 15411	MG PLAYMATIKA (15411) Betpassion DARK
    '54F0DDFE-D936-4637-0002-E4B319EE5173',	// 15459	MG GIOCONDABET (15459) Giocondabet DARK
    '13E3D502-9EA8-412F-0002-29E00512EB0D',	// 15469	MG SLOT PLUS (15469) Chescommessa DARK
    'E1AF081A-FFA0-4255-0002-349E05D48773',	// 15469	MG SLOT PLUS (15469) Signorbet DARK
    '350A1AD6-B06D-403E-0002-177AD81D4F4A',	// 15473	MG WIN BET ONLINE (15473) Winbet DARK
    'A191D31B-849B-4329-0002-737FE16B32E9',	// 15479	MG ITALY GAMING (15479) Elabet DARK
    '74FB227A-8A74-4962-0002-8848BE685C16', // Betsense
    'D74209E4-4920-4A87-0002-FC5581F58CD0', // Puntoscommesse
    'E70F45DD-2803-478B-0002-0A06E2350549', // Giochitelematici
    '089CF0AB-7771-4376-0002-F063068028A5', // Mediabet
    '5ABDD1C3-95D6-4840-0002-1A2328373498', // Gazzabet DARK
    '550E6A37-17F0-481E-0002-057EA7AB103B', // Giocaagile DARK
    '332EA976-4830-4172-0002-E0BEE253DBBE', // Airbet DARK
    '5E84A947-AE1B-4AC7-0002-5888353DA73E', // Monkeybet DARK
    '104914B4-FB0B-4129-0002-5E980323B6A9', // Venetianbet DARK
    '8106DBF5-895B-41C9-0002-CF415BEB025C', // Dgbet DARK
    '4190C345-52D7-472D-0002-CE14B04C7125',	// 15188	29	MG VITTORIA BET 2009 (15188) Tiltbet DARK
    '98778980-8BBC-4C99-0002-21FBACC5F3F0',    // MG STREET WEB (15245) Acbet DARK
    '46E286A7-4184-411E-0002-59DF14E43705',    // MG STREET WEB (15245) Apbet DARK
    '710D09A0-BAEE-4DA4-0002-C473D54DC28F',    // MG STREET WEB (15245) Galaxybet DARK
    '1FA5A573-E6D8-46B7-0002-A0CE5CAFD2B8',    // MG STREET WEB (15245) Mpbet DARK
    '0A851CB3-D1F8-4325-0002-9F2DE35E4702',    // MG STREET WEB (15245) Powerbet DARK
    '515A8BE5-6F2D-4966-0002-C72EEFFA8DDE',    // MG STREET WEB (15245) Terrybet DARK
    '5EB95E71-7256-47D8-0002-4D6EB8254636', // MG VITTORIA BET 2009 (15188) Casinobellagio LIGHT
    '80C35A32-0687-459C-0002-1376D8C13E57',  // MG MICROGAME (15112) Bilionairebet DARK
    'D68739D9-240D-47AF-0002-EC6CB4528AE2',  // MG MICROGAME (15112) Microgamenewbos DARK




    // PROD
    'D1433264-56E8-45F4-0002-27772BD837F5', // Betsense
    'DC7D8CB3-113E-4954-0002-1C4ECBBEE63F', // Puntoscommesse
    'A3AAC37C-31E1-48FB-0002-B9F9095D268D', // Giochitelematici
    '33499C2A-DAC4-44ED-0002-3095F5EBEEFA', // Mediabet
    '3629CBC6-3F94-4DC5-0002-B431BC5497BE', // Gazzabet DARK
    '1F3371A2-6C94-4208-0002-5C8DC0A0D719', // Giocaagile DARK
    '8E23364B-E71E-4898-0002-A9059ACB8B31', // Airbet DARK
    '46919431-46C2-4F1B-0002-4E5F71D77B6B', // Monkeybet DARK
    'D27339D9-D1C9-4295-0002-42EED6D30BA7', // Venetianbet DARK
    '5F3AB2D0-9C1B-4434-0002-46DEA0F7E3DC', // Dgbet Dark
    'BFBFE48A-23AB-47BA-0002-13F50C63EC6D',    // 15073    MG REPLATZ (15073) Betman DARK
    '14B13D85-7830-4690-0002-D3A60882F833',    // 15073    MG REPLATZ (15073) Replatz DARK
    '1C167ED0-6CA4-41C0-0002-1175D624F891',    // 15074    MG GI.LU.PI. (15074) Betscore DARK
    '7E0AF456-695B-4DAB-0002-506CA80CBEB3',    // 15074    MG GI.LU.PI. (15074) Betitaly DARK
    'BD4DB8F4-8CA5-4FC5-0002-6EF65292BA9A',    // 15074    MG GI.LU.PI. (15074) Giocasempre DARK
    'EB9D2B37-294C-4290-0002-0B374A9DF9FB',    // 15092    MG PLIVIO (15092) Eventogioco DARK
    '41D37132-57FF-45CC-0002-A6B9C58B9E15',    // 15092    MG PLIVIO (15092) Eventogiocobet DARK
    'F7C79590-CA67-4B40-0002-074120503C2A',    // 15188    MG VITTORIA BET 2009 (15188) Wintoto DARK
    '3F07E162-EF3A-4D38-0002-5F252A790F44',    // 15188    MG VITTORIA BET 2009 (15188) Bettime DARK
    '08B8BDD2-F0DD-416A-0002-678525A81507',    // 15188    MG VITTORIA BET 2009 (15188) Deabet DARK
    '024C5EC8-ABE2-4A47-0002-B69F539EEBCA',    // 15188    MG VITTORIA BET 2009 (15188) Andromedabet DARK
    '996F689F-8032-4934-0002-B72DD83558D3',    // 15188    MG VITTORIA BET 2009 (15188) Lafenicebet DARK
    'AF8E9E01-EADC-4DB3-0002-DBB690B60049',    // 15188    MG VITTORIA BET 2009 (15188) Chancebet DARK
    '46C875DC-B34E-4C18-0002-E79DFCF037CC',    // 15405    MG TOTOSI (15405) Totosi DARK
    '0F8F81AE-9194-4457-0002-79FD528A7E11',    // 15411    MG PLAYMATIKA (15411) Betnow DARK
    '0D636D5F-FCD9-4B93-0002-C068489C3BAA',    // 15411    MG PLAYMATIKA (15411) Betpassion DARK
    'A8CBC7E8-B2E3-4239-0002-CAD5E8B9A9C4',    // 15411    MG PLAYMATIKA (15411) Playmatika DARK
    '74ED4F0B-33C7-4D8A-0002-B74C6D147612',    // 15459    MG GIOCONDABET (15459) Giocondabet DARK
    'D3C800F5-C269-4580-0002-861FB5FE5DCF',    // 15469    MG SLOT PLUS (15469) Chescommessa DARK
    '3AF82845-9657-4214-0002-B29E8C55C465',    // 15469    MG SLOT PLUS (15469) Signorbet DARK
    '75F2174A-1DBF-46C7-0002-652BC201A10F',    // 15473    MG WIN BET ONLINE (15473) Winbet DARK
    'E67502C1-20BE-401D-0002-5BA53D10CE2E',    // 15479    MG ITALY GAMING (15479) Elabet DARK
    '2C97BFC3-874D-4C20-0002-3DC31D845CA5',	   // 15188	   MG VITTORIA BET 2009 (15188) Tiltbet LIGHT
    '7C39C599-A7EF-48E6-0002-477C1A215E81',    // MG STREET WEB (15245) Acbet DARK
    'B03D1CCD-21E7-4969-0002-73146CD61CFA',    // MG STREET WEB (15245) Apbet DARK
    '7A6EFA71-E02F-4710-0002-527F9F71E52F',    // MG STREET WEB (15245) Galaxybet DARK
    'FB820655-48D7-44BC-0002-1C86CCE5C1DA',    // MG STREET WEB (15245) Mpbet DARK
    'DD6DDB19-6B26-4E95-0002-BCCA07351EB3',    // MG STREET WEB (15245) Powerbet DARK
    'F5189891-F295-43F8-0002-AB75FE90C62C',    // MG STREET WEB (15245) Terrybet DARK
    'D607F904-FC28-412E-0002-470BD8524EEA',     // MG VITTORIA BET 2009 (15188) Casinobellagio DARK
    '5D7FE983-A823-4043-0002-1024B276F36D',     // MG MICROGAME (15112) Bilionairebet Dark
    '62FA01C8-9BC0-436B-0002-897360C24191'      // MG MICROGAME (15112) Microgamenewbos DARK

];

export const microgameLight = [
    // TEST
    '11522B8F-8D18-467E-AFBC-7168E826BB56', // Staging Test Microgame

    'E8CD9BBD-BF67-4156-0001-8F79C7950207',	// 15073	MG REPLATZ (15073) Betman LIGHT
    '6CBB64AF-3BFA-43F0-0001-9031DA2403C8',	// 15073	MG REPLATZ (15073) Replatz LIGHT
    'E62C3DEA-20FD-4F13-0001-0EE8487DB021',	// 15074	MG GI.LU.PI. (15074) Giocasempre LIGHT
    '06EEBAC3-7100-45EA-0001-EE42F1327911',	// 15074	MG GI.LU.PI. (15074) Betscore LIGHT
    '08E2817C-6E8D-4BAE-0001-F7C7882BD063',	// 15074	MG GI.LU.PI. (15074) Betitaly LIGHT
    'F8864412-00EE-47D3-0001-9DA5F7108F89',	// 15092	MG PLIVIO (15092) Eventogioco LIGHT
    '9439F5C1-0697-435E-0001-BA008138741D',	// 15092	MG PLIVIO (15092) Eventogiocobet LIGHT
    '9236D5AA-AB59-473B-0001-276FB0429BD1',	// 15188	MG VITTORIA BET 2009 (15188) Deabet LIGHT
    'BA2F4385-A537-46B2-0001-86EDB3F42262',	// 15188	MG VITTORIA BET 2009 (15188) Chancebet LIGHT
    'F9251ED8-B9CF-401C-0001-8A64E8B50E93',	// 15188	MG VITTORIA BET 2009 (15188) Andromedabet LIGHT
    '9E997CDF-F7F8-49A7-0001-92C7D18C28F5',	// 15188	MG VITTORIA BET 2009 (15188) Lafenicebet LIGHT
    '7BB8BF4C-8B31-4AF0-0001-A90F9F051683',	// 15188	MG VITTORIA BET 2009 (15188) Bettime LIGHT
    'EE17B44E-77E9-482B-0001-D0AB2E1E17B2',	// 15188	MG VITTORIA BET 2009 (15188) Wintoto LIGHT
    '04E8007B-5737-40CC-0001-5B0F64169708',	// 15405	MG TOTOSI (15405) Totosi LIGHT
    '1DC89CFB-1763-40F7-0001-1C11644DCD62',	// 15411	MG PLAYMATIKA (15411) Betnow LIGHT
    '03FCFEA9-C818-4C24-0001-A416DCEBB975',	// 15411	MG PLAYMATIKA (15411) Playmatika LIGHT
    '65E26070-E679-4544-0001-FB45A4E0964D',	// 15411	MG PLAYMATIKA (15411) Betpassion LIGHT
    '54F0DDFE-D936-4637-0001-E4B319EE5173',	// 15459	MG GIOCONDABET (15459) Giocondabet LIGHT
    '13E3D502-9EA8-412F-0001-29E00512EB0D',	// 15469	MG SLOT PLUS (15469) Chescommessa LIGHT
    'E1AF081A-FFA0-4255-0001-349E05D48773',	// 15469	MG SLOT PLUS (15469) Signorbet LIGHT
    '350A1AD6-B06D-403E-0001-177AD81D4F4A',	// 15473	MG WIN BET ONLINE (15473) Winbet LIGHT
    'A191D31B-849B-4329-0001-737FE16B32E9',	// 15479	MG ITALY GAMING (15479) Elabet LIGHT
    '74FB227A-8A74-4962-0001-8848BE685C16', // Betsense
    'D74209E4-4920-4A87-0001-FC5581F58CD0', // Puntoscommesse
    'E70F45DD-2803-478B-0001-0A06E2350549', // Giochitelematici
    '089CF0AB-7771-4376-0001-F063068028A5', // Mediabet
    '5ABDD1C3-95D6-4840-0001-1A2328373498', // Gazzabet
    '550E6A37-17F0-481E-0001-057EA7AB103B', // Giocaagile
    '332EA976-4830-4172-0001-E0BEE253DBBE', // Airbet
    '5E84A947-AE1B-4AC7-0001-5888353DA73E', // Monkeybet
    '104914B4-FB0B-4129-0001-5E980323B6A9', // Venetianbet
    '8106DBF5-895B-41C9-0001-CF415BEB025C', // Dgbet
    '4190C345-52D7-472D-0001-CE14B04C7125',	// 15188	29	MG VITTORIA BET 2009 (15188) Tiltbet LIGHT
    '98778980-8BBC-4C99-0001-21FBACC5F3F0',    // MG STREET WEB (15245) Acbet
    '46E286A7-4184-411E-0001-59DF14E43705',    // MG STREET WEB (15245) Apbet
    '710D09A0-BAEE-4DA4-0001-C473D54DC28F',    // MG STREET WEB (15245) Galaxybet
    '1FA5A573-E6D8-46B7-0001-A0CE5CAFD2B8',    // MG STREET WEB (15245) Mpbet
    '0A851CB3-D1F8-4325-0001-9F2DE35E4702',    // MG STREET WEB (15245) Powerbet
    '515A8BE5-6F2D-4966-0001-C72EEFFA8DDE',    // MG STREET WEB (15245) Terrybet
    '5EB95E71-7256-47D8-0001-4D6EB8254636', // MG VITTORIA BET 2009 (15188) Casinobellagio LIGHT
    '80C35A32-0687-459C-0001-1376D8C13E57',  // MG MICROGAME (15112) Bilionairebet LIGHT
    'D68739D9-240D-47AF-0001-EC6CB4528AE2',  // MG MICROGAME (15112) Microgamenewbos LIGHT


    // PROD
    'D1433264-56E8-45F4-0001-27772BD837F5', // Betsense
    'DC7D8CB3-113E-4954-0001-1C4ECBBEE63F', // Puntoscommesse
    'A3AAC37C-31E1-48FB-0001-B9F9095D268D', // Giochitelematici
    '33499C2A-DAC4-44ED-0001-3095F5EBEEFA', // Mediabet
    '3629CBC6-3F94-4DC5-0001-B431BC5497BE', // Gazzabet
    '1F3371A2-6C94-4208-0001-5C8DC0A0D719', // Giocaagile
    '8E23364B-E71E-4898-0001-A9059ACB8B31', // Airbet
    '46919431-46C2-4F1B-0001-4E5F71D77B6B', // Monkeybet
    'D27339D9-D1C9-4295-0001-42EED6D30BA7', // Venetianbet
    '5F3AB2D0-9C1B-4434-0001-46DEA0F7E3DC', // Dgbet
    'BFBFE48A-23AB-47BA-0001-13F50C63EC6D',    // 15073    MG REPLATZ (15073) Betman LIGHT
    '14B13D85-7830-4690-0001-D3A60882F833',    // 15073    MG REPLATZ (15073) Replatz LIGHT
    '1C167ED0-6CA4-41C0-0001-1175D624F891',    // 15074    MG GI.LU.PI. (15074) Betscore LIGHT
    '7E0AF456-695B-4DAB-0001-506CA80CBEB3',    // 15074    MG GI.LU.PI. (15074) Betitaly LIGHT
    'BD4DB8F4-8CA5-4FC5-0001-6EF65292BA9A',    // 15074    MG GI.LU.PI. (15074) Giocasempre LIGHT
    'EB9D2B37-294C-4290-0001-0B374A9DF9FB',    // 15092    MG PLIVIO (15092) Eventogioco LIGHT
    '41D37132-57FF-45CC-0001-A6B9C58B9E15',    // 15092    MG PLIVIO (15092) Eventogiocobet LIGHT
    'F7C79590-CA67-4B40-0001-074120503C2A',    // 15188    MG VITTORIA BET 2009 (15188) Wintoto LIGHT
    '3F07E162-EF3A-4D38-0001-5F252A790F44',    // 15188    MG VITTORIA BET 2009 (15188) Bettime LIGHT
    '08B8BDD2-F0DD-416A-0001-678525A81507',    // 15188    MG VITTORIA BET 2009 (15188) Deabet LIGHT
    '024C5EC8-ABE2-4A47-0001-B69F539EEBCA',    // 15188    MG VITTORIA BET 2009 (15188) Andromedabet LIGHT
    '996F689F-8032-4934-0001-B72DD83558D3',    // 15188    MG VITTORIA BET 2009 (15188) Lafenicebet LIGHT
    'AF8E9E01-EADC-4DB3-0001-DBB690B60049',    // 15188    MG VITTORIA BET 2009 (15188) Chancebet LIGHT
    '46C875DC-B34E-4C18-0001-E79DFCF037CC',    // 15405    MG TOTOSI (15405) Totosi LIGHT
    '0F8F81AE-9194-4457-0001-79FD528A7E11',    // 15411    MG PLAYMATIKA (15411) Betnow LIGHT
    '0D636D5F-FCD9-4B93-0001-C068489C3BAA',    // 15411    MG PLAYMATIKA (15411) Betpassion LIGHT
    'A8CBC7E8-B2E3-4239-0001-CAD5E8B9A9C4',    // 15411    MG PLAYMATIKA (15411) Playmatika LIGHT
    '74ED4F0B-33C7-4D8A-0001-B74C6D147612',    // 15459    MG GIOCONDABET (15459) Giocondabet LIGHT
    'D3C800F5-C269-4580-0001-861FB5FE5DCF',    // 15469    MG SLOT PLUS (15469) Chescommessa LIGHT
    '3AF82845-9657-4214-0001-B29E8C55C465',    // 15469    MG SLOT PLUS (15469) Signorbet LIGHT
    '75F2174A-1DBF-46C7-0001-652BC201A10F',    // 15473    MG WIN BET ONLINE (15473) Winbet LIGHT
    'E67502C1-20BE-401D-0001-5BA53D10CE2E',    // 15479    MG ITALY GAMING (15479) Elabet LIGHT
    '2C97BFC3-874D-4C20-0001-3DC31D845CA5',	   // 15188	   MG VITTORIA BET 2009 (15188) Tiltbet LIGHT
    '7C39C599-A7EF-48E6-0001-477C1A215E81',    // MG STREET WEB (15245) Acbet LIGHT
    'B03D1CCD-21E7-4969-0001-73146CD61CFA',    // MG STREET WEB (15245) Apbet LIGHT
    '7A6EFA71-E02F-4710-0001-527F9F71E52F',    // MG STREET WEB (15245) Galaxybet LIGHT
    'FB820655-48D7-44BC-0001-1C86CCE5C1DA',    // MG STREET WEB (15245) Mpbet LIGHT
    'DD6DDB19-6B26-4E95-0001-BCCA07351EB3',    // MG STREET WEB (15245) Powerbet LIGHT
    'F5189891-F295-43F8-0001-AB75FE90C62C',    // MG STREET WEB (15245) Terrybet LIGHT
    'D607F904-FC28-412E-0001-470BD8524EEA',     // MG VITTORIA BET 2009 (15188) Casinobellagio LIGHT
    '5D7FE983-A823-4043-0001-1024B276F36D',     // MG MICROGAME (15112) Bilionairebet LIGHT
    '62FA01C8-9BC0-436B-0001-897360C24191'      // MG MICROGAME (15112) Microgamenewbos LIGHT
];

export const newgioco = [
    '5A9F3ABC-06D7-435F-8A8F-651DD98C0587', // staging NEWGIOCO
    'C61AE6B3-2100-4C81-BDBD-7DB912CDDB33'  // NEWGIOCO
];

export const originalbet = [
    '76AF41F3-B7E3-4088-BF85-A4E65137E4CD', // staging ORIGINALBET
    '4AB15D18-8E40-4FFB-8FBF-EC1F32DE0191',  // ORIGINALBET

    '7D4F7207-ADAC-4A69-8C8E-636CF124CC9F', // staging TEKNOGAME
    '5F68F436-63B7-403C-BE0E-C74F41D84AC4' // TEKNOGAME
];

export const lovingbet = [
    '2F6106DB-4A68-40B7-B3E8-A7691E70E9DC', // staging - LOVINGBET
    'A5662CC7-FD70-4560-9B7A-F74126783455' // LOVINGBET
];

export const timetobet = [
    '19148C48-017F-43B2-9510-CFF4048CED1D', // staging - TIMETOBET
    'F982CDAB-E80F-4BAF-8C02-B1914C03870B' // TIMETOBET
];

export const clubgames = [
    '9BD2F0A1-B52A-4E88-A718-1BB34E2EA1C3', // staging - TIMETOBET
    '295ADD00-10A9-4F3C-88A2-E0C891D6A8C2' // TIMETOBET
];

export const quibet = [
    '766E6356-9748-4875-8D89-A83966BA0361', // staging - QUIBET
    '615D68F8-0C44-4B2B-A7D1-A24D39F1751E' // QUIBET
];

export const newbetlive5k = [
    'A6B987F8-DA26-468C-898E-27D71CBAA53C', // staging - NEWBETLIVE5k
    'DEDD484A-4C16-4841-A20E-A3D948E186A3' // NEWBETLIVE5k
];

export const elysgame = [
    '43849BCB-B83B-4049-A8A8-54ACA8B43C39', // staging - ELYSGAME
    'B82E3B4F-4DAC-4731-8DA6-9733DE52FC2A' // ELYSGAME
];

export const betstation = [
    '1FE4F7B6-1FE6-4BC8-827A-40BC4B72076F', // staging - betstation
    'A0832BDD-B4B0-426B-AB98-0C26D3E45BF8' // betstation
];

export const domusbet = [
    'A752844B-A8A9-4908-95E8-D42D1AB1CD0E', // staging - domusbet
    '2352EF83-4594-4B0B-A337-B56E6EAE6D99' // domusbet
];

export const betpremium = [
    '27898781-7E0A-40CD-8687-63E7B67AE00E', // staging - betpremium
    '35F06F7B-EF7A-4FA3-A7A3-F05FA7FF99E3' // betpremium
];

export const jokando = [
    '7859D046-3FC0-421D-93D4-7C6FB0BA6A0C', // NETWIN staging - JOKANDO
    '027886C1-E023-4DAC-BAD3-A156E58160CB' // NETWIN - JOKANDO
];

export const netwin = [
    'BC4B5B16-0224-448E-8653-C1BA33E06C30', // staging NETWIN
    '7301E685-1351-4EA5-B6EC-F2362363B7B7' // Netwin
];

export const admiral = [
    '9804E124-93A5-411C-AA7C-DD9E55153000', // staging admiral
    '4F8578A5-78B5-445E-A480-2441D9EC4B7B', // admiral
    'B439200D-EF69-4E97-B320-DFD110BB7225', // QUIGIOCO - ADMIRAL777
    'EA93E1A8-F02E-4BC2-B57C-62CE44ABCA48' // QUIGIOCO - ADMIRAL777
];

export const betmatch = [
    'B55E93CF-E170-4732-8D3A-0E7F57271B93', //   FIVEBET - BETMATCH staging
    'ADE09A17-3FCA-4612-A43C-E1C14B8F84B7' //    FIVEBET - BETMATCH
];

export const fivebet = [
    '6E4A2A80-4CFE-4C39-9499-6A8F920EDFA5', //    FIVEBET - FIVEBET staging
    '232140AD-9354-4061-98EB-5CF223403A81'  // FIVEBET - FIVEBET
];

export const fullslot = [
    '5747B1F7-C79D-4BAC-A0ED-8E8C3CEAF211', //    FIVEBET - FULLSLOT staging
    '0EB19B08-CA6A-491C-9529-0E3FBE8D8C59'  //   FIVEBET - FULLSLOT
];

export const giocoyes = [
    '6E698F05-A803-4A6B-B70A-4C9D6C3747E2',  // FIVEBET - GIOCOYES
    'DDA66045-2E98-4047-876D-1417A27FEE8D'   // FIVEBET - GIOCOYES
];
export const i7betplus = [
    '124BDC86-32B3-4552-803A-F046D6AA1BB8', //    FIVEBET - I7BETPLUS
    '87200280-7FF7-4801-998F-F3A20ABB9106'  //  FIVEBET - I7BETPLUS
];
export const iambet = [
'EEB98811-9EAF-4E3D-85ED-E590CABFE698',   // FIVEBET - IAMBET
'9AEE8D0A-0704-4602-B0A1-B721B5BEF9A0'    // FIVEBET - IAMBET
];
export const onegol = [
    '02961FA6-0F4E-4A76-A0FE-8E7E6333C1BD', //   FIVEBET - ONEGOL
    'D4687225-6A7E-496D-8237-0570CCE53533' //    FIVEBET - ONEGOL
];
export const pointbet = [
    'C79A79B2-F282-4D7F-A788-9E3EDB535D5B', //  FIVEBET - POINTBET
    'A5DABEB0-921B-4711-A68C-84F3B11352C5'  //  FIVEBET - POINTBET
];
export const pokerbet = [
    'A94373A0-503E-4384-B0AF-753A3088C741', //  FIVEBET - POKER-BET
    '2F462B30-0000-4302-946A-9786F6668657' //   FIVEBET - POKER-BET
];
export const sportanfgames = [
    'E86E859D-E6BC-492D-A06A-8E78FC9585D4', // FIVEBET - SPORTANDGAMES
    '50D2BFCF-1FF1-4689-9597-B4E1E493A494'    // FIVEBET - SPORTANDGAMES
];
export const timewin = [
    '33572647-84CA-4B0D-8125-BDDE1BEB45A9', //    FIVEBET - TIMEWIN
    '6E716CE2-5374-412A-ADAD-18B935471085'  //   FIVEBET - TIMEWIN
];
export const vincitubet = [
    '419060C3-060A-4FDD-B26A-D2CF7A734F8E', //  FIVEBET - VINCITUBET
    'C0BCFFF3-1A36-4E01-9262-1B9CD439AD77'  //  FIVEBET - VINCITUBET
];
export const allinbet = [
    'E9905018-0B43-4E5E-AE42-2FFA21586E38',     // BGAME - ALLINBET
    '88A9714D-7C35-418B-9C15-F6505FEF36BF'      // BGAME - ALLINBET
];
export const bbet = [
    '3E96A51C-9D08-401C-9DEA-59B9B3897C23',   // BGAME - BBET
    'F553352C-8016-4EA5-8EA9-61C53A52D916'    // BGAME - BBET
];
export const bgame = [
    '2F52B995-3847-4E44-B615-A53DC21B0E47', //    BGAME - BGAME
    'DCF56C0F-3233-435A-8762-04E199B94A14' //    BGAME - BGAME
];
export const bullbet = [
    '66FDB1F1-66CE-45AB-9A21-5CF7D9F7F8BA', //   BGAME - Mbet
    '96B7787E-74E7-4731-81C0-618B8A4748BC'  //  BGAME - Mbet
];
export const dngames = [
    '78DEE16B-D4EC-41E0-A9F9-A492C655F87E', //    BGAME - DNGAMES
    'B4E6D9C0-9DFE-407B-9322-ED760C0D37F0' //    BGAME - DNGAMES
];
export const gamex = [
    'F320FD01-1D09-43E3-B73E-E8B82E9A1AA5',    // BGAME - GAM-X
    '776BAA89-78E8-439E-BA22-75AB097252AE'    // BGAME - GAM-X
];
export const minniebet = [
    '1E4D54A5-3386-4402-8645-8A6B0960C2DE',   //  BGAME - MINNIEBET
    '7A60C461-3A8B-4C1B-BB27-97C08A4DAEDC'   //  BGAME - MINNIEBET
];
export const q365 = [
    '1E2195F8-3E65-42EB-973C-5EBF529073C1', //    BGAME - Q365
    'E58506EC-F22F-48DA-9303-D20583C9EBF4' //    BGAME - Q365
];
export const skilljoy = [
    '782732C1-7376-4742-98DC-C380F1954DEA',    // BGAME - SKILLJOY
    '8FC4B976-8D6C-4ED8-A414-FF9F5D082974' //    BGAME - SKILLJOY
];
export const socialgames24 = [
    '536D5050-0DEE-428A-A063-B56010E9BD8D',   // BGAME - SOCIALGAME24
    'E63925D0-EEE1-4423-BD63-6A1D91FBA1C5'    // BGAME - SOCIALGAME24
];
export const sportbull = [
    '608FE4E0-D64D-4BB4-96F3-0259BDDD9C33',   //  BGAME - SPORTBULL
    'F54FC40C-8620-40F4-86B7-8437325240F9'   //  BGAME - SPORTBULL
];
export const topbet24 = [
    'FEFB376B-13F7-4B22-84B4-0C57B0F1A635', //   BGAME - TOPBET24
    'E791D035-A2CA-46B8-BF91-53FB57079D76'  //  BGAME - TOPBET24
];
export const uninonsbet = [
    '9116E751-1D17-470C-AF35-BE1CA0EA7CF7',  //  BGAME - UNIONSBET
    'F451A5CD-1D34-4AD0-9106-239A2C436279'  //  BGAME - UNIONSBET
];
export const vincitu = [
    '02072A25-877A-4EFC-8C09-43898C45EA50', // vinitu prod
    '338AE1BC-2DA8-4CE5-9DC7-DC5121184B1E', // vinitu staging
];
